import axios from "axios";
import authHeader from '../../../authheader'

const VFRENEWALURL = process.env.REACT_APP_APIURL + "/api/FirmVfRenewal";

const getViolation = (renewalId) => {
    return axios.get(`${VFRENEWALURL}/violation`, { headers: authHeader(), params: { renewalId } });
}
const postViolation = (data) => {
    return axios.post(`${VFRENEWALURL}/violation`, data, { headers: authHeader() });
}
export default {
    getViolation,
    postViolation
}